import React from 'react';
import { View, Text, Image, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { SHADOWS } from '../../constants/theme';
import { parseDescriptionToText, getImageUrl } from './utils';

const HubitaLogo = require('../../assets/images/Logo/HubitaWeb.png');

const MediaComponent = ({ image, coverImage, title, description, date, category, onPress, isMobile }) => {
  // Parse description cleanly if stringified Draft.js JSON or HTML
  const cleanDescription = parseDescriptionToText(description);

  // Resolve cover image with fallback URL formatting
  const resolvedImage = getImageUrl(coverImage || image);

  return (
    <TouchableOpacity
      style={[styles.card, isMobile && styles.cardMobile]}
      onPress={onPress}
      activeOpacity={0.9}
    >
      {/* Image Banner or Hubita Logo Placeholder */}
      {resolvedImage ? (
        <View style={styles.imageWrap}>
          <Image source={{ uri: resolvedImage }} style={styles.image} />
          {category && (
            <View style={styles.categoryBadge}>
              <Text style={styles.categoryText}>{category}</Text>
            </View>
          )}
        </View>
      ) : (
        <View style={styles.imagePlaceholder}>
          <Image
            source={HubitaLogo}
            style={styles.logoPlaceholder}
            resizeMode="contain"
          />
          {category && (
            <View style={styles.categoryBadge}>
              <Text style={styles.categoryText}>{category}</Text>
            </View>
          )}
        </View>
      )}

      {/* Card Content Container with uniform height */}
      <View style={styles.body}>
        <View style={styles.textGroup}>
          {date ? <Text style={styles.dateText}>{date}</Text> : null}

          <Text style={styles.title} numberOfLines={2}>
            {title || 'Media Article'}
          </Text>

          {cleanDescription ? (
            <Text style={styles.description} numberOfLines={2}>
              {cleanDescription}
            </Text>
          ) : null}
        </View>

        <View style={styles.footer}>
          <Text style={styles.readMoreText}>Read Article</Text>
          <Ionicons name="arrow-forward" size={14} color="#6C2BD9" />
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#F3F4F6',
    overflow: 'hidden',
    marginBottom: 20,
    width: '100%',
    height: 370,
    ...SHADOWS.sm,
  },
  cardMobile: {
    borderRadius: 14,
    marginBottom: 16,
    height: 370,
  },
  imageWrap: {
    width: '100%',
    height: 170,
    backgroundColor: '#F9FAFB',
    position: 'relative',
  },
  imagePlaceholder: {
    width: '100%',
    height: 170,
    backgroundColor: '#F0E8FF',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  logoPlaceholder: {
    width: 140,
    height: 48,
  },
  image: {
    width: '100%',
    height: '100%',
    resizeMode: 'cover',
  },
  categoryBadge: {
    position: 'absolute',
    top: 12,
    left: 12,
    backgroundColor: 'rgba(108, 43, 217, 0.9)',
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 20,
  },
  categoryText: {
    color: '#FFFFFF',
    fontSize: 11,
    fontWeight: '700',
  },
  body: {
    padding: 16,
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 200,
  },
  textGroup: {
    flex: 1,
  },
  dateText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#6C2BD9',
    marginBottom: 4,
  },
  title: {
    fontSize: 16,
    fontWeight: '700',
    color: '#111827',
    lineHeight: 22,
    marginBottom: 6,
  },
  description: {
    fontSize: 13,
    color: '#6B7280',
    lineHeight: 19,
  },
  footer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    marginTop: 'auto',
    paddingTop: 8,
  },
  readMoreText: {
    fontSize: 13,
    fontWeight: '700',
    color: '#6C2BD9',
  },
});

export default MediaComponent;
